import { Pipe, PipeTransform } from '@angular/core';
import { AratData, Assessment, BbsData, BbtData, FrData, Mwt6Data, NhptData, TsData, TugData } from '../services/model';

@Pipe({
  name: 'assessmentNotes',
  standalone: true,
})
export class AssessmentNotesPipe implements PipeTransform {
  transform(assessment: Assessment): string {
    if (assessment.note) {
      return assessment.note;
    }
    if (assessment.type === 'ARAT') {
      const aratData = assessment.data as AratData;
      let note = '';
      note += aratData.grasp.note ? '1. Greifen: ' + aratData.grasp.note + '\n' : '';
      note += aratData.grip.note ? '2. Griff: ' + aratData.grip.note + '\n' : '';
      note += aratData.pinch.note ? '3. Präzisionsgriff: ' + aratData.pinch.note + '\n' : '';
      note += aratData.gross.note ? '4. Basale Armbewegung: ' + aratData.gross.note + '\n' : '';
      return note;
    } else if (assessment.type === 'BBT') {
      const bbtData = assessment.data as BbtData;
      return bbtData.bbt.note;
    } else if (assessment.type === 'BBS') {
      const data = assessment.data as BbsData;
      return data.bbs.note;
    } else if (assessment.type === 'TS') {
      const data = assessment.data as TsData;
      return data.ts.note;
    } else if (assessment.type === 'FR') {
      const data = assessment.data as FrData;
      return data.fr.note;
    } else if (assessment.type === 'NHPT') {
      const nhptData = assessment.data as NhptData;
      return nhptData.nhpt.note;
    } else if (assessment.type === 'MWT6') {
      const data = assessment.data as Mwt6Data;
      return data.mwt6.note;
    } else if (assessment.type === 'TUG') {
      const data = assessment.data as TugData;
      return data.tug.note;
    } else {
      return '';
    }
  }
}
